var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewspaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.54541,
    width: 40,
    height: 40,
    rx: 20,
    className: "ext2_2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ext2_2_i",
    d: "M13.0454 15.4999C12.6312 15.4999 12.2954 15.8357 12.2954 16.2499C12.2954 16.6641 12.6312 16.9999 13.0454 16.9999H26.5454C26.9596 16.9999 27.2954 16.6641 27.2954 16.2499C27.2954 15.8357 26.9596 15.4999 26.5454 15.4999H13.0454Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ext2_2_i",
    d: "M12.6704 18.4999C12.4633 18.4999 12.2954 18.6678 12.2954 18.8749C12.2954 19.082 12.4633 19.2499 12.6704 19.2499H26.9204C27.1275 19.2499 27.2954 19.082 27.2954 18.8749C27.2954 18.6678 27.1275 18.4999 26.9204 18.4999H12.6704Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ext2_2_i",
    d: "M22.7954 21.1249C22.7954 20.9178 22.9633 20.7499 23.1704 20.7499H26.9204C27.1275 20.7499 27.2954 20.9178 27.2954 21.1249C27.2954 21.332 27.1275 21.4999 26.9204 21.4999H23.1704C22.9633 21.4999 22.7954 21.332 22.7954 21.1249Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ext2_2_i",
    d: "M23.1704 22.9999C22.9633 22.9999 22.7954 23.1678 22.7954 23.3749C22.7954 23.582 22.9633 23.7499 23.1704 23.7499H26.9204C27.1275 23.7499 27.2954 23.582 27.2954 23.3749C27.2954 23.1678 27.1275 22.9999 26.9204 22.9999H23.1704Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "ext2_2_i",
    d: "M22.7954 25.6249C22.7954 25.4178 22.9633 25.2499 23.1704 25.2499H26.9204C27.1275 25.2499 27.2954 25.4178 27.2954 25.6249C27.2954 25.832 27.1275 25.9999 26.9204 25.9999H23.1704C22.9633 25.9999 22.7954 25.832 22.7954 25.6249Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "ext2_2_i",
    d: "M23.1704 27.4999C22.9633 27.4999 22.7954 27.6678 22.7954 27.8749C22.7954 28.082 22.9633 28.2499 23.1704 28.2499H26.9204C27.1275 28.2499 27.2954 28.082 27.2954 27.8749C27.2954 27.6678 27.1275 27.4999 26.9204 27.4999H23.1704Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "ext2_2_i",
    d: "M12.2954 22.2499C12.2954 21.4215 12.967 20.7499 13.7954 20.7499H19.7954C20.6238 20.7499 21.2954 21.4215 21.2954 22.2499V26.7499C21.2954 27.5783 20.6238 28.2499 19.7954 28.2499H13.7954C12.967 28.2499 12.2954 27.5783 12.2954 26.7499V22.2499Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "ext2_2_i",
    d: "M14.5455 10.9999C13.717 10.9999 13.0454 11.6714 13.0454 12.4999H11.5166C10.2349 12.4999 9.29541 13.5632 9.29541 14.7499V28.2499C9.29541 29.8508 10.5578 31.2499 12.2377 31.2499H30.2954L30.3081 31.2498C31.1307 31.243 31.7954 30.5741 31.7954 29.7499V12.4998C31.7954 11.6714 31.1239 10.9998 30.2955 10.9998C27.5595 10.9997 25.5735 10.9998 22.8375 10.9998C20.0735 10.9999 17.3095 11 14.5455 10.9999ZM28.0743 13.9999C28.4196 13.9999 28.7082 14.2523 28.7789 14.5894C28.7897 14.6411 28.7954 14.6948 28.7954 14.7498V28.2499C28.7954 29.0783 29.467 29.7499 30.2954 29.7499H12.2377C11.4412 29.7499 10.7954 29.0783 10.7954 28.2499V14.7499C10.7954 14.3357 11.1183 13.9999 11.5166 13.9999H28.0743Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaper);
export default __webpack_public_path__ + "static/media/Newspaper.2e5e8cc1.svg";
export { ForwardRef as ReactComponent };